import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import {
  SeekerBookingsService,
  SeekerBookingItem,
} from '../../../services/seeker-bookings.service';
import { TranslatePipe } from '../../../../../../core/pipes/translate.pipe';
import { TicketCreationModalComponent } from '../../../../../../shared/components/ticket-creation-modal/ticket-creation-modal';

@Component({
  selector: 'app-bookings',
  standalone: true,
  imports: [CommonModule, TranslatePipe, TicketCreationModalComponent],
  templateUrl: './bookings.html',
  styleUrl: './bookings.scss',
})
export class Bookings implements OnInit {
  private service = inject(SeekerBookingsService);
  private router = inject(Router);

  bookings: SeekerBookingItem[] = [];
  loading = true;
  error: string | null = null;
  showTicketModal = false;
  selectedBookingForTicket: SeekerBookingItem | null = null;

  ngOnInit(): void {
    this.service.getBookings().subscribe({
      next: (res) => {
        this.bookings = res.bookings;
        this.loading = false;
      },
      error: (err) => {
        this.error = err.message || 'Failed to load bookings';
        this.loading = false;
      },
    });
  }

  formatDate(d: string): string {
    return new Date(d).toLocaleDateString('en-GB');
  }

  statusClass(status: string): string {
    const map: Record<string, string> = {
      pending: 'badge badge-warning',
      confirmed: 'badge badge-success',
      completed: 'badge badge-primary',
      cancelled: 'badge badge-danger',
    };
    return map[status.toLowerCase()] ?? 'badge badge-secondary';
  }

  get activeCount(): number {
    return this.bookings.filter((b) => b.status === 'confirmed').length;
  }

  viewUnit(booking: SeekerBookingItem): void {
    this.router.navigate(['/rent', booking.unitId]);
  }

  contactOwner(booking: SeekerBookingItem): void {
    // Fallback behavior: open the related unit details where owner contact actions exist.
    this.router.navigate(['/rent', booking.unitId], {
      queryParams: { contactOwner: '1' },
      fragment: 'contact-owner',
    });
  }

  openTicketModal(booking: SeekerBookingItem): void {
    this.selectedBookingForTicket = booking;
    this.showTicketModal = true;
  }

  closeTicketModal(): void {
    this.showTicketModal = false;
    this.selectedBookingForTicket = null;
  }

  onTicketCreated(): void {
    this.closeTicketModal();
  }
}
